import styled, { css } from 'styled-components';
import { rem, cssVar, rgba } from 'polished';
import { prefix } from '../../tools/settings';

var customPadding = function customPadding(props) {
  if (typeof props.padding === 'number') {
    return props.padding + 'px';
  } else {
    return props.padding;
  }
};

var cardPadding = function cardPadding(props) {
  return props.padding ? customPadding : props.isLinkCard ? 0 : 'var(--dentsu-spacing-24)';
};

var CardGroup = styled.div.withConfig({
  displayName: "Cardstyles__CardGroup",
  componentId: "sc-3ee21f-0"
})(["display:flex;flex-wrap:wrap;padding:", "px;.", "-card{margin:", "px;width:", ";}"], function (props) {
  return props.spacing / 2;
}, prefix, function (props) {
  return props.spacing / 2;
}, function (props) {
  return "calc(".concat(100 / props.cols, "% - ").concat(props.spacing, "px)");
});
var Card = styled.div.withConfig({
  displayName: "Cardstyles__Card",
  componentId: "sc-3ee21f-1"
})(["background:var(--dentsu-color-white);color:var(--dentsu-color-n1000);font-size:var(--dentsu-font-size-14);font-weight:var(--dentsu-font-weight-regular);word-break:break-word;position:relative;display:flex;flex-direction:column;padding:", ";pointer-events:", ";cursor:", ";opacity:", ";", ";", ";&:hover{box-shadow:", ";}&.", "-card--editorial{text-align:center;}"], cardPadding, function (props) {
  return props.isDisabled ? 'none' : 'auto';
}, function (props) {
  return props.isDisabled ? 'not-allowed' : 'auto';
}, function (props) {
  return props.isDisabled ? 0.4 : 1;
}, function (props) {
  return props.hasBorder && css(["border:1px solid var(--dentsu-color-n250);border-top-color:var(--dentsu-color-n350);"]);
}, function (props) {
  return props.variant === 'list' && css(["margin-bottom:var(--dentsu-spacing-8);"]);
}, function (props) {
  return props.hasBorder ? 'var(--dentsu-shadow-2)' : 'none';
}, prefix);
var CardAction = styled.a.withConfig({
  displayName: "Cardstyles__CardAction",
  componentId: "sc-3ee21f-2"
})(["color:var(--dentsu-color-n1000);padding:", ";text-decoration:none;", " &:focus{outline:none;box-shadow:0 0 0 ", " ", ";}&:hover{color:var(--dentsu-color-n1000);text-decoration:none;*{text-decoration:none;}}"], function (props) {
  return props.variant === 'media' ? 0 : 'var(--dentsu-spacing-24)';
}, function (props) {
  return props.isDisabled && css(["pointer-events:none;cursor:not-allowed;"]);
}, rem(4), rgba(cssVar('--dentsu-color-p150', '#cebaed'), 0.6));
export var Styled = {
  CardGroup: CardGroup,
  Card: Card,
  CardAction: CardAction
};